import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { assignPatientBranch } from '../../../api/protocol';
import { HandleApiError } from '../../../components/Notifications/APIErrorHandler';
import { Success } from '../../../components/Notifications/Notifications';
import { useBranches } from './useBranches';

/**
 * Modal obligatorio que bloquea el flujo "Nueva Entrada → Visita Protocolar"
 * cuando la próxima visita requiere rama y el paciente aún no tiene una asignada.
 */
export const BranchInterceptModal = ({ isShowing, protocolId, numberInProtocol, onSuccess, onCancel }) => {
    const { t } = useTranslation();
    const [branches] = useBranches(protocolId);
    const [selectedBranchId, setSelectedBranchId] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    if (!isShowing) return null;

    const handleConfirm = async () => {
        if (!selectedBranchId) return;
        setIsSubmitting(true);
        try {
            await assignPatientBranch(protocolId, numberInProtocol, parseInt(selectedBranchId, 10));
            Success('protocolNotifications.branch_Assigned');
            onSuccess && onSuccess(parseInt(selectedBranchId, 10));
        } catch (error) {
            HandleApiError(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return ReactDOM.createPortal(
        <Modal show backdrop="static" onHide={onCancel}>
            <Modal.Header>
                <Modal.Title>{t('protocols.branches.interceptTitle')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>{t('protocols.branches.interceptDescription')}</p>
                <select
                    className="form-control"
                    value={selectedBranchId}
                    onChange={e => setSelectedBranchId(e.target.value)}
                >
                    <option value="">{t('protocols.branches.selectBranchPlaceholder')}</option>
                    {branches.map(branch => (
                        <option key={branch.id} value={branch.id}>{branch.name}</option>
                    ))}
                </select>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onCancel} disabled={isSubmitting}>{t('buttons.cancel')}</Button>
                <Button
                    bsStyle="primary"
                    disabled={isSubmitting || !selectedBranchId}
                    onClick={handleConfirm}
                >
                    {t('buttons.confirm')}
                </Button>
            </Modal.Footer>
        </Modal>,
        document.body
    );
};
